import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { StoreBrandResponse, StoreLocationResponse } from '../models/response.module';

interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data: T;
}

@Injectable({
  providedIn: 'root'
})
export class StoreLocatorService {
  private apiUrl = environment.coreApiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Get all active store brands
   */
  getBrands(): Observable<StoreBrandResponse[]> {
    return this.http.get<ApiResponse<StoreBrandResponse[]>>(
      `${this.apiUrl}store-locator/brands`
    ).pipe(map(res => res.data));
  }

  /**
   * Get all store locations with optional brand filter
   */
  getLocations(brandIds?: number[]): Observable<StoreLocationResponse[]> {
    let url = `${this.apiUrl}store-locator/locations`;
    if (brandIds && brandIds.length > 0) {
      url += `?brand_ids=${brandIds.join(',')}`;
    }
    return this.http.get<ApiResponse<StoreLocationResponse[]>>(url)
      .pipe(map(res => res.data));
  }

  /**
   * Get locations for a specific brand
   */
  getLocationsByBrand(brandId: number): Observable<StoreLocationResponse[]> {
    return this.http.get<ApiResponse<StoreLocationResponse[]>>(
      `${this.apiUrl}store-locator/locations/${brandId}`
    ).pipe(map(res => res.data));
  }
}
